import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--fd-space-space-3);
  max-width: 100%;
  width: 100%;
`;
